
<ul class="pager">
  <!-- Non utilisé dans la version précedente -->
  <!-- <li class="page-item">
    <a class="page-link" (click)="goTo(1)">{{ firstText }}</a>
  </li> -->
  <li class="page-item">
    <a class="page-link" (click)="goTo(page - 1)">{{ previousText }}</a>
  </li>
  <li class="page-item">
    <a class="page-link" (click)="goTo(page + 1)">{{ nextText }}</a>
  </li>
  <!-- Non utilisé dans la version précedente -->
  <!-- <li class="page-item">
    <a class="page-link" (click)="goTo(totalPages)">{{ lastText }}</a>
  </li> -->
</ul>